<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card border border-radius-12">
          <div class="card-body table mb-0">
                                                <div class="toolbar-container px-3">
              <div class="toolbar-row d-flex align-items-center justify-content-between mb-2">
                  <PageHeader
                    :title="title"
                    :items="itemsBreadcrumb"
                    class="poppins fw-normal ps-3 text-nowrap"
                  />
                <div class="d-flex gap-2 flex-wrap p-0 buttons-container">
                  <CustomButton 
                    :buttonText="downloadReportProcessing ? 'Please wait...' : 'Download Report'"
                    :loading = "downloadReportProcessing"
                    class="p-0"
                    @click="downloadReport" 
                  />
                </div>
              </div>

              <div class="toolbar-row d-flex gap-2 align-items-center">
               <searchInput @getSearched="handleSearch" class="p-0" />
                <pageSize @getPageSize="handlePageSize" class="page-size-btn p-0"/> 
              </div>
            </div>

            <GeneralTable
              :isProcessing="processing"
              :items="items"
              :fields="fields"
              @no-records-found="onRecordsFount"
              :showEyeButton="true"
              :showActionButton="false"
              @showItem="showEmail"
            />

            <b-modal
              ref="email-modal"
              hide-footer
              isModalVisible
              title="Email Preview"
              size="md"
            >
              <template v-slot:default>
                <div v-if="emailLoading">
                  <APILoader :loading="emailLoading" class="align-middle text-center" />
                </div>

                <div v-else>
                  <div v-if="selectedEmail">
                    <iframe
                      class="email-iframe"
                      :srcdoc="selectedEmail.content || ''"
                      sandbox=""
                    ></iframe>
                  </div>

                  <div v-else class="text-center">
                    <p>No email data available.</p>
                  </div>
                </div>
              </template>
            </b-modal>

            <Pagination
              @paginator="getEmails"
              :pagination="paginatelinks"
              :showing="paginate"
              @page-changed="handlePageChange"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/static/main";
import PageHeader from "@/components/static/page-header";
import appConfig from "@/app.config";
import GeneralTable from "../../../../components/MagicTable/GeneralTable.vue";
import Pagination from "../../../../components/general/pagination.vue";
import searchInput from "../../../../components/general/searchInput.vue";
import pageSize from "../../../../components/general/pageSize.vue";
import CustomButton from "../../../../components/CustomButton.vue";
import APILoader from "@/components/general/APILoader.vue";

export default {
  page: {
    title: "Outgoing Emails",
    meta: [
      {
        name: "email-notifications",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    GeneralTable,
    Pagination,
    searchInput,
    pageSize,
    CustomButton,
    APILoader,
  },

  data() {
    return {
      title: "Outgoing Emails",

      fields: [
        { key: "id", label: "ID", tdClass: "align-middle" },
        { key: "recipient_email", label: "Receiver Email", tdClass: "align-middle" },
        { key: "subject", label: "Subject", tdClass: "align-middle" },
        { key: "opens", label: "Opens", tdClass: "align-middle" },
        { key: "clicked_at", label: "Click At", tdClass: "align-middle" },
        { key: "clicks", label: "Clicks", tdClass: "align-middle" },
        { key: "created_at", label: "Sent At", tdClass: "align-middle" },
        { key: "action", tdClass: "" },
      ],

      items: [],
      processing: false,

      paginate: {},
      paginatelinks: [],
      pageSize: 25,
      search: null,

      selectedEmail: null,
      emailLoading: false,

      downloadReportProcessing: false,
    };
  },

  computed: {
    itemsBreadcrumb() {
      return [
        { text: "Omaha" },
        { text: "Emails Notification", active: true },
      ];
    },
  },

  mounted() {
    let url = null;
    if (this.$route.query.currentPage) {
      url = `email-notifications?page=${this.$route.query.currentPage}`;
    }
    this.getEmails({ url, pageSize: this.pageSize });
    this.processing = true;
  },

  methods: {
    openEmailModal() {
      this.$refs["email-modal"].show();
    },

    formatDate(isoDate) {
      if (!isoDate) return "N/A";

      const date = new Date(isoDate);
      if (isNaN(date.getTime())) return isoDate;

      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "long" });
      const year = date.getFullYear();

      const getDaySuffix = (d) => {
        if (d > 3 && d < 21) return "th";
        switch (d % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      };

      return `${day}${getDaySuffix(day)} ${month} ${year}`;
    },

    // TABLE CALLBACKS
    onRecordsFount() {
      this.getEmails({ pageSize: this.pageSize, searchItem: null });
    },

    handleSearch(searchItem) {
      this.search = searchItem;
      this.getEmails({ searchItem, pageSize: this.pageSize });
    },

    handlePageSize(newPageSize) {
      this.pageSize = newPageSize || 25;
      this.getEmails({ pageSize: this.pageSize, searchItem: this.search });
    },

    handlePageChange(pageNumber) {
      const baseUrl = "email-notifications";
      const pageUrl = `${baseUrl}?page=${pageNumber}`;
      this.getEmails({ url: pageUrl, pageSize: this.pageSize, searchItem: this.search });
    },

    // EYE BUTTON
    showEmail(emailId) {
      this.emailLoading = true;
      this.selectedEmail = null;

      this.$axios
        .get(`email-notifications/${emailId}`)
        .then((response) => {
          const email = response?.data?.data || response?.data || null;
          this.selectedEmail = email;
          this.emailLoading = false;
          this.openEmailModal();
        })
        .catch((error) => {
          console.log("Error fetching email:", error?.response || error);
          this.emailLoading = false;
        });
    },

    randerData(response) {
      const payload = response?.data || {};

      this.paginate = {
        first_page: payload.first_page_url,
        last_page_url: payload.last_page_url,
        last_page: payload.last_page,
        links: payload.links,
        from: payload.from,
        to: payload.to,
        total: payload.total,
      };

      this.paginatelinks = (this.paginate.links || []).map((item) => ({
        url: item.url,
        label: item.label,
        active: item.active,
      }));

      const rows = Array.isArray(payload?.data) ? payload.data : [];

      this.items = rows.map((row) => ({
        id: row.id,
        recipient_email: row.recipient_email || "N/A",
        subject: row.subject || "N/A",
        opens: row.opens ?? 0,
        clicks: row.clicks ?? 0,
        clicked_at: this.formatDate(row.clicked_at),
        created_at: this.formatDate(row.created_at),
      }));

      this.processing = false;
    },

    getEmails({ url = null, searchItem = null, pageSize = this.pageSize } = {}) {
      this.processing = true;

      let endPoint = "email-notifications";
      endPoint = url ? url : endPoint;

      this.$axios
        .get(endPoint, {
          params: {
            search: searchItem,
            per_page: pageSize,
          },
        })
        .then((response) => {
          setTimeout(() => this.randerData(response), 300);
        })
        .catch((error) => {
          console.log(error?.response || error);
          this.processing = false;
        });
    },

    async downloadReport() {
      if (this.downloadReportProcessing) return;

      this.downloadReportProcessing = true;

      try {
        const total = this.paginate?.total || 0;

        if (!total) {
          this.triggerSwal?.("No data available to download.", "warning");
          return;
        }

        const response = await this.$axios.get("email-notifications", {
          params: {
            search: this.search,
            per_page: total,
          },
        });

        const payload = response?.data || {};
        const rows = Array.isArray(payload?.data) ? payload.data : [];

        if (!rows.length) {
          this.triggerSwal?.("No data available to download.", "warning");
          return;
        }

        const headers = [
          "ID",
          "Receiver Email",
          "Subject",
          "Opens",
          "Clicks",
          "Clicked At",
          "Sent At",
        ];

        const csvRows = rows.map((row) => [
          row.id,
          row.recipient_email || "N/A",
          row.subject || "N/A",
          row.opens ?? 0,
          row.clicks ?? 0,
          row.clicked_at ? this.formatDate(row.clicked_at) : "N/A",
          row.created_at ? this.formatDate(row.created_at) : "N/A",
        ]);

        let csvContent = headers.join(",") + "\n";

        csvRows.forEach((row) => {
          csvContent +=
            row
              .map((value) =>
                `"${String(value ?? "")
                  .replace(/"/g, '""')
                  .replace(/\n/g, " ")}"`
              )
              .join(",") + "\n";
        });

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `email-notifications-${Date.now()}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error);
        this.triggerSwal?.("Something went wrong while downloading.", "error");
      } finally {
        this.downloadReportProcessing = false;
      }
    },

  },
};
</script>

<style scoped>
.email-iframe {
  width: 100%;
  height: 70vh;
  border: 1px solid #ddd;
  border-radius: 10px;
  background: #fff;
}
.toolbar-container {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
}

.toolbar-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  width: 100%;
}

@media (max-width : 576px){
  .card-body{
    padding : 0.25rem !important;
  }
  .toolbar-row {
    justify-content: flex-start;
  }

  .toolbar-row:first-child {
    flex-direction: column;
    align-items: flex-start;
  }
  .buttons-container{
    width : 100%;
  }
}
@media (max-width: 768){
  .table > :not(caption) > * > *
  {
    padding: 0.25rem !important;
  }
}
</style>
